import { Row, Col } from "antd";
import ProfileStatus from "../../components/ProfileStatus";
import UpcomingEvents from "../../components/UpcomingEvents";
import UserTypePrompt from "../../components/UserTypePrompt";

const Dashboard = () => {
  return (
    <>
      <UserTypePrompt />
      <Row gutter={20} justify="center">
        <Col xs={24} md={14} lg={10} xl={12}>
          <UpcomingEvents />
        </Col>
        <Col xs={24} md={10} lg={8} xl={4}>
          <ProfileStatus />
        </Col>
      </Row>
    </>
  );
};

export default Dashboard;
